import { API, type ApiService } from "@packages/common";
import type { User } from "@packages/domain";
import { Query, QueryFn, QueryKey } from "@packages/query";
import { Inject } from "@webmotors/ioc";

export const USER_DATA_QUERY = "USER_DATA_QUERY";

/**
 * Subset of the PF "dados-usuario" payload (`Retorno`) used to enrich the
 * analytics `user` node, mirroring the garagem flow
 * (Id / Sexo / DataNascimento / Cidade / Uf).
 */
export type UserDataDTO = {
  Id?: number;
  Sexo?: string;
  DataNascimento?: string;
  Cidade?: string;
  Uf?: string;
};

type UserDataApiResponse = {
  Retorno?: UserDataDTO;
};

@Query(USER_DATA_QUERY)
export class UserDataQuery {
  constructor(
    @Inject(API)
    private readonly apiService: ApiService
  ) {}

  @QueryKey
  queryKey(user: User | null) {
    return [USER_DATA_QUERY, user?.id ?? null];
  }

  @QueryFn
  queryFn(user: User | null): Promise<UserDataDTO | null> {
    if (!user) return Promise.resolve(null);

    return this.apiService
      .post<{ hash: string }, UserDataApiResponse>(
        "/pf/v1/acesso/dados-usuario",
        { hash: "" },
        { headers: { authorization: user.authenticationToken } }
      )
      .then((response) => response?.Retorno ?? null)
      .catch(() => null);
  }
}
